const API_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:8080"
    : import.meta.env.VITE_API_URL;

// Delete account
async function deleteAccount(email) {
  try {
    const res = await fetch(`${API_URL}/api/delete-account`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    console.log(`RES: ${res}`);

    if (res.ok) {
      return true;
    }

    console.error(`Account deletion failed with status: ${res.status}`);
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

// Report a bug
async function reportABug(email, description) {
  try {
    console.log(`Sending bug report: ${description}`);
    const res = await fetch(`${API_URL}/api/report`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, description }),
    });

    if (res.status === 500) {
      return false;
    }

    return true;
  } catch (e) {
    return null;
  }
}

export { deleteAccount, reportABug };
